// @flow

import _ from 'lodash';
import ApiObject from '../ApiObject';
import ArrayUtils from '../../utils/ArrayUtils';

import ProRole from './ProRole';

export default class ProRolesList extends ApiObject {

  roles: Array<ProRole> = [];

  postJsonAssignation(data: Object) {
    this.roles = [];
    _.each(data, (roleData) => {
      const proRole:ProRole = new ProRole();
      proRole.fromJson(roleData);
      this.roles.push(proRole);
    });
  }

  getWithId(roleId: string) {
    const found = _.find(this.roles, (role: ProRole) => {
      // let ==
      return role.id == roleId;
    });

    return _.isUndefined(found) ? null : found;
  }

  push(role: ProRole) {
    this.roles.push(role);
  }

  update(role: ProRole) {
    this.roles = ArrayUtils.updateObjectOrAdd(this.roles, role, (other: ProRole) => {
      return role.id === other.id;
    });
  }

  delete(role: ProRole) {
    this.roles = ArrayUtils.deleteObject(this.roles, (other: ProRole) => {
      return role.id === other.id;
    });
  }
}
